import { render, staticRenderFns } from "./WalletStakeModal.vue?vue&type=template&id=61fabdfa&"
import script from "./WalletStakeModal.vue?vue&type=script&lang=js&"
export * from "./WalletStakeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports